import Logo from '@components/icons/Logo.svg';

type TProps = {
  hideText?: boolean;
};

export const VsLogo = ({ hideText = false }: TProps) => (
  <div className="flex flex-col items-start text-[var(--color-logo)] [&_svg]:h-auto">
    <Logo />
    {!hideText ? (
      <p className="m-0 -mt-0.5 p-0 text-xs font-medium leading-[130%] tracking-[0.02em] text-[var(--color-text-muted)]">
        Powered by VoiceScript Inc
      </p>
    ) : null}
  </div>
);
